// extracted by mini-css-extract-plugin
module.exports = {"dialpad-button-wrapper":"ChatButton_dialpad-button-wrapper__Rfc9C","dialpad-button":"ChatButton_dialpad-button__hPqSu"};